/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkAddContainertypeDto } from '../models/work-add-containertype-dto';
import { WorkAddUserDto } from '../models/work-add-user-dto';
import { WorkCreateReservationteamDto } from '../models/work-create-reservationteam-dto';
import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkRemoveContainertypeDto } from '../models/work-remove-containertype-dto';
import { WorkRemoveUserDto } from '../models/work-remove-user-dto';
import { WorkReservationteam } from '../models/work-reservationteam';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateReservationteamDto } from '../models/work-update-reservationteam-dto';

@Injectable({ providedIn: 'root' })
export class WorkReservationteamsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `reservationteamsV2ControllerFindAllPaginated()` */
  static readonly ReservationteamsV2ControllerFindAllPaginatedPath = '/v2/reservationteams';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> businessunitId:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>businessunitId</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'businessunitId:ASC' | 'businessunitId:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> businessunit.name,users.firstName,users.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>businessunit.name</li>
     * <li>users.firstName</li>
     * <li>users.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkReservationteam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkReservationteam>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> businessunitId:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>businessunitId</li>
     * <li>active</li></ul>
     */
      sortBy?: Array<'businessunitId:ASC' | 'businessunitId:DESC' | 'active:ASC' | 'active:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> businessunit.name,users.firstName,users.lastName
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>businessunit.name</li>
     * <li>users.firstName</li>
     * <li>users.lastName</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkReservationteam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}> {
    return this.reservationteamsV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkReservationteam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkReservationteam>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
};
};
} => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerCreate()` */
  static readonly ReservationteamsV2ControllerCreatePath = '/v2/reservationteams';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerCreate$Response(
    params: {
      containertypeIdsToAdd?: Array<number>;
      body: WorkCreateReservationteamDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationteam>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerCreatePath, 'post');
    if (params) {
      rb.query('containertypeIdsToAdd', params.containertypeIdsToAdd, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationteam>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerCreate(
    params: {
      containertypeIdsToAdd?: Array<number>;
      body: WorkCreateReservationteamDto
    },
    context?: HttpContext
  ): Observable<WorkReservationteam> {
    return this.reservationteamsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationteam>): WorkReservationteam => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerGetAllDropdownOptions()` */
  static readonly ReservationteamsV2ControllerGetAllDropdownOptionsPath = '/v2/reservationteams/dropdown-options';

  /**
   * Required permissions: reservationteams:read, reservationteams:admin, reservations:read, reservations:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: reservationteams:read, reservationteams:admin, reservations:read, reservations:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.reservationteamsV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerFindOneById()` */
  static readonly ReservationteamsV2ControllerFindOneByIdPath = '/v2/reservationteams/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerFindOneById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerFindOneById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationteam>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerFindOneByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationteam>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerFindOneById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerFindOneById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkReservationteam> {
    return this.reservationteamsV2ControllerFindOneById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationteam>): WorkReservationteam => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerDelete()` */
  static readonly ReservationteamsV2ControllerDeletePath = '/v2/reservationteams/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationteamsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.reservationteamsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerUpdate()` */
  static readonly ReservationteamsV2ControllerUpdatePath = '/v2/reservationteams/{id}';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateReservationteamDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkReservationteam>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkReservationteam>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateReservationteamDto
    },
    context?: HttpContext
  ): Observable<WorkReservationteam> {
    return this.reservationteamsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkReservationteam>): WorkReservationteam => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerAddUserToReservationteam()` */
  static readonly ReservationteamsV2ControllerAddUserToReservationteamPath = '/v2/reservationteams/{id}/users';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerAddUserToReservationteam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerAddUserToReservationteam$Response(
    params: {
      id: number;
      body: WorkAddUserDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerAddUserToReservationteamPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerAddUserToReservationteam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerAddUserToReservationteam(
    params: {
      id: number;
      body: WorkAddUserDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.reservationteamsV2ControllerAddUserToReservationteam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerRemoveUserFromReservationteam()` */
  static readonly ReservationteamsV2ControllerRemoveUserFromReservationteamPath = '/v2/reservationteams/{id}/users';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerRemoveUserFromReservationteam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerRemoveUserFromReservationteam$Response(
    params: {
      id: number;
      body: WorkRemoveUserDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerRemoveUserFromReservationteamPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerRemoveUserFromReservationteam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerRemoveUserFromReservationteam(
    params: {
      id: number;
      body: WorkRemoveUserDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.reservationteamsV2ControllerRemoveUserFromReservationteam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerAddContainertypeToReservationteam()` */
  static readonly ReservationteamsV2ControllerAddContainertypeToReservationteamPath = '/v2/reservationteams/{id}/containertypes';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerAddContainertypeToReservationteam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerAddContainertypeToReservationteam$Response(
    params: {
      id: number;
      body: WorkAddContainertypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerAddContainertypeToReservationteamPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerAddContainertypeToReservationteam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerAddContainertypeToReservationteam(
    params: {
      id: number;
      body: WorkAddContainertypeDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.reservationteamsV2ControllerAddContainertypeToReservationteam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `reservationteamsV2ControllerRemoveContainertypeFromReservationteam()` */
  static readonly ReservationteamsV2ControllerRemoveContainertypeFromReservationteamPath = '/v2/reservationteams/{id}/containertypes';

  /**
   * Required permissions: all:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationteamsV2ControllerRemoveContainertypeFromReservationteam()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerRemoveContainertypeFromReservationteam$Response(
    params: {
      id: number;
      body: WorkRemoveContainertypeDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkReservationteamsV2Service.ReservationteamsV2ControllerRemoveContainertypeFromReservationteamPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: all:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `reservationteamsV2ControllerRemoveContainertypeFromReservationteam$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationteamsV2ControllerRemoveContainertypeFromReservationteam(
    params: {
      id: number;
      body: WorkRemoveContainertypeDto
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.reservationteamsV2ControllerRemoveContainertypeFromReservationteam$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
